<template>
    <div class="main-container">
        <div class="edit-panel pa-5">
            <h4>{{ $t('presales_prices') }}</h4>
            <v-form ref="form" :disabled="!record.userCanSave(authUser)" @input="$emit('input', $event)">
                <v-row dense class="mt-2">
                    <v-col cols="12">
                        <LabelField :label="$t('vorverkauf_reservation')">
                            <v-textarea
                                :value="record.standard_text_tickets"
                                :placeholder="$t('placeholder_event_additional_info_standard_text_tickets')"
                                rows="5"
                                dense
                                outlined
                                hide-details="auto"
                                counter
                                @input="onInput('standard_text_tickets', $event)"
                            />
                        </LabelField>
                        <LabelField :label="$t('link_vorverkauf')" class="mt-6">
                            <UrlField
                                :value="record.presales_link"
                                :placeholder="$t('placeholder_event_additional_info_presales_link')"
                                @input="onInput('presales_link', $event)"
                            />
                        </LabelField>
                        <LabelField :label="$t('preise_kosten')" class="mt-6">
                            <v-textarea
                                :value="record.ticketprices"
                                :placeholder="$t('placeholder_event_additional_info_ticketprices')"
                                rows="4"
                                dense
                                outlined
                                hide-details="auto"
                                @input="onInput('ticketprices', $event)"
                            />
                        </LabelField>
                    </v-col>
                </v-row>
            </v-form>
        </div>

        <div class="info-panel pa-5">
            <!-- info -->
            <KpAlert type="info" style="max-width: 600px">
                <h4>{{ $t('add_info_doks') }}</h4>
                <p>
                    Du möchtest noch weitere Infos zum Event erfassen? Zum beispiel Dokumente hochladen oder weitere
                    Links platzieren? Wechsle hierfür in die erweiterte Erfassungsmaske.
                </p>
                <ActionBtn :to="{ name: 'event-info-categories', params: { id: record.id } }">
                    <KpIcon icon-cls="next" color="white" />
                    {{ $t('new_event_erweitert') }}
                </ActionBtn>
            </KpAlert>
        </div>
    </div>
</template>

<script>
import { userIsStaff } from '@/helpers/auth';
import GlobalsMixin from '@/mixins/globals';
import getRulesMixin from '@/mixins/get-form-rules';

import { Event } from '@/models/Event';
import { mapState } from 'vuex';

export default {
    name: 'EventExpressEditInfo',
    mixins: [GlobalsMixin, getRulesMixin],
    props: {
        record: {
            type: Event,
            required: true,
        },
        // used to indicate form validity
        value: Boolean,
    },
    data() {
        return {
            isValid: false,
        };
    },
    computed: {
        ...mapState('user', {
            authUser: 'record',
        }),
    },
    methods: {
        userIsStaff,
        onInput(field, value) {
            this.record.set(field, value);
        },
        validateForm() {
            this.$refs.form.validate();
        },

        onSave() {
            this.$emit('save');
        },
    },
};
</script>

<style lang="scss" scoped>
.main-container {
    overflow: auto;
    display: grid;
    grid-template-areas: 'edit info';
    grid-template-rows: auto;
    grid-template-columns: minmax(440px, 800px) minmax(300px, 1fr);
    overflow: auto;
}

.edit-panel {
    grid-area: edit;
}
.info-panel {
    grid-area: info;
    background-color: var(--toolbar-bg-color);
}

.field-content {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.fieldset1-col,
.fieldset2-col {
    min-width: 300px;
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 0;
}
</style>
